import { useQuery, UseQueryResult } from 'react-query';
import { UrlParams, OtherWorkTypeAutoComplete } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteOtherWorkTypesProps {
  search: string;
}

function useAutoCompleteOtherWorkTypes({
  search,
}: IUseAutoCompleteOtherWorkTypesProps): UseQueryResult<{ data: Array<OtherWorkTypeAutoComplete> }> {
  const params: UrlParams = {};
  if (search) {
    params.search = search;
  }

  return useQuery(['other-work-types-autocomplete', search], () =>
    client.get(`other-work-types/auto-complete/?${encodeUrlParams(params)}`),
  );
}

export default useAutoCompleteOtherWorkTypes;
